import axios from "axios";

const instance = axios.create({
  // 服务端请求添加baseURL（因为服务端请求不会在路径前加上当前域名）
  baseURL: typeof window === 'undefined' ? process.env.NEXT_PUBLIC_API_URL : '',
  // timeout: 10 * 1000,
});

instance.interceptors.request.use(
  (config) => {
    // console.log("请求拦截", config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // console.log("响应拦截", response);
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
